import * as companyActions from '../actions/companyActions';
import * as companyRegionsActions from '../actions/companyRegionsActions';
import * as countryActions from '../actions/countryActions';
import * as companyMunicipalityActions from '../actions/companyMunicipalityActions';
import * as articleTemplateActions from '../actions/articleTemplateActions';
import * as articleCategoryActions from '../actions/articleCategoryActions';
import * as jobActions from '../actions/jobActions';


/**
 * Config with required action by the route. Key should be route, value is set of imported actions.
 * @example {
 *     '/profil/rediger': [
 *          loadCompanyCategories,
 *          loadCompanyPortals,
 *      ]
 * }
 * */
export default {
    // create company profile
    '/profil/skab': [
        companyActions.loadCompanyCategories,
        companyActions.loadCompanyPortals,
    ],

    // edit company information
    '/profil/stamdata': [
        countryActions.loadCountries,
        companyRegionsActions.loadCompanyRegions,
        companyMunicipalityActions.loadCompanyMunicipalities,
    ],

    // create article
    '/nyhed/skab': [
        articleTemplateActions.loadTemplates,
        articleCategoryActions.loadCategories,
    ],

    // update article
    '/nyhed/redigere/:id': [
        articleTemplateActions.loadTemplates,
        articleCategoryActions.loadCategories,
    ],


    // create job
    '/jobopslag/skab': [
        jobActions.loadJobRegions,
        jobActions.loadJobCategories,
        jobActions.loadJobWorkingTimes,
    ],

    // update job
    '/jobopslag/redigere/:id': [
        jobActions.loadJobRegions,
        jobActions.loadJobCategories,
        jobActions.loadJobWorkingTimes,
    ],
}



// WEBPACK FOOTER //
// ./web/src/common/requiredActionsConfig.js